/**
 * Theme analytics — sends product_clicked events to PostHog.
 *
 * Listens to `click` (capture phase) and delivers via `sendBeacon`, which the
 * browser queues even as the page unloads — so the event survives the
 * navigation the click triggers, without the race that drops Shopify's
 * standard `clicked` web-pixel event.
 *
 * NOTE: this previously used `pointerdown` to beat that race, but on touch
 * devices a scroll-start fires `pointerdown` over whatever card is under the
 * finger, inflating product_clicked ~7x with phantom hits (and burning the
 * PostHog free-tier quota). A real `click` never fires on scroll, and
 * `sendBeacon` covers delivery, so it's both accurate and cheaper.
 *
 * Product context is read from `data-product-*` attributes on the
 * `[data-product-card]` wrapper rendered by `snippets/card-product.liquid`.
 */
(function () {
  if (typeof window === 'undefined') return;

  function findProductLink(target) {
    if (!target || !target.closest) return null;
    var link = target.closest('a[href]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    return href.indexOf('/products/') !== -1 ? link : null;
  }

  function findProductCard(target) {
    return target && target.closest ? target.closest('[data-product-card]') : null;
  }

  function getPositionInList(card) {
    var parent = card.parentElement;
    if (!parent) return null;
    var siblings = parent.querySelectorAll(':scope > [data-product-card]');
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === card) return i + 1;
    }
    return null;
  }

  function getList() {
    try {
      var path = window.location.pathname || '';
      var collectionMatch = path.match(/^\/collections\/([^\/]+)/);
      if (collectionMatch) return 'collection:' + collectionMatch[1];
      if (path.indexOf('/search') === 0) return 'search';
      if (path.indexOf('/products/') === 0) return 'pdp-related';
      if (path === '/' || path === '') return 'home';
      return path;
    } catch (e) {
      return null;
    }
  }

  function toNumber(value) {
    if (value == null || value === '') return null;
    var cleaned = String(value).replace(/[^0-9.\-]/g, '');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function captureProductClick(event) {
    if (typeof window.posthog === 'undefined' || !window.posthog.capture) return;

    var link = findProductLink(event.target);
    if (!link) return;

    var card = findProductCard(event.target);
    if (!card) return;

    window.posthog.capture('product_clicked', {
      product_id: card.dataset.productId || null,
      product_handle: card.dataset.productHandle || null,
      product_title: card.dataset.productTitle || null,
      product_price: toNumber(card.dataset.productPrice),
      product_vendor: card.dataset.productVendor || null,
      product_type: card.dataset.productType || null,
      product_variant_id: card.dataset.productVariantId || null,
      product_url: link.getAttribute('href'),
      list: getList(),
      position: getPositionInList(card),
    }, { transport: 'sendBeacon' });
  }

  // DISABLED 2026-06-23 to conserve the PostHog free-tier event quota (~4k events/day).
  // product_clicked is no longer used for reporting — all product/revenue analytics now
  // run off checkout_completed line items, which are exact and cover every payment method
  // (Apple Pay/Shop Pay included). Re-enable by uncommenting the line below.
  // document.addEventListener('click', captureProductClick, { capture: true });
})();
